import { useEffect, useState, type FC } from 'react';
import styles from './index.module.scss';
import searchIcon from '@assets/images/vault/search.svg';
import Popover from '@ui/parrot/popover';
import closeIcon from '@assets/images/vault/close.svg';
import CoinCheck from './coin-check';
import { type CoinStruct } from '@models/coins.vault.model';
import { useToggle } from 'react-use';

interface OwnProps {
  searchValue: CoinStruct[];
  onChangeSearchValue(value: CoinStruct[]): void;
}
const VaultSearch: FC<OwnProps> = ({ searchValue, onChangeSearchValue }) => {
  const [openSearch, toggleOpenSearch] = useToggle(false);
  const [searchName, setSearchName] = useState('');

  const removeSearch = (value: CoinStruct) => {
    const result = searchValue.filter((item) => item.coin_type !== value.coin_type);
    onChangeSearchValue(result);
  };

  const addSearch = (value: CoinStruct) => {
    const result = [...searchValue, value];
    onChangeSearchValue(result);
  };

  useEffect(() => {
    if (!openSearch) {
      setSearchName('');
    }
  }, [openSearch]);

  return (
    <Popover
      onOpenChange={() => {
        searchValue.length < 2 && toggleOpenSearch();
      }}
      open={openSearch}
      content={
        <CoinCheck
          addSearch={addSearch}
          data={searchValue}
          toggleOpenSearch={toggleOpenSearch}
          removeSearch={removeSearch}
          searchName={searchName}
          onChangeSearchName={setSearchName}
        />
      }
      trigger={'click'}
    >
      <div className={styles.wrapper}>
        <div
          className={`${styles.left} ${
            openSearch || searchValue.length > 0 ? styles.left_init : ''
          }`}
        >
          <img src={searchIcon} />
          <span>search</span>
        </div>
        <div className={styles.right}>
          {searchValue.map((item) => (
            <div
              className={styles.item}
              key={item.coin_type}
              onClick={(e) => {
                e.stopPropagation();
                removeSearch(item);
              }}
            >
              <img src={item.icon} className={styles.coin_icon} />
              <span>{item.symbol}</span>
              <img src={closeIcon} className={styles.close_icon} />
            </div>
          ))}
        </div>
      </div>
    </Popover>
  );
};

export default VaultSearch;
